export enum ESettingsType {
    block_agenda = "block_agenda",
    online = "online",
    first_appointment = "first_appointment",
    partnerships = "partnerships"
}